import React from 'react';
import PropTypes from 'prop-types';
import { Confirm, Message } from 'semantic-ui-react';

// Same Confirm dialog the VRA Pending "allow" action uses (Cancel / OK), plus a title and a close
// icon. There is nothing to collect from the user, so this stays a plain yes/no confirmation.
function ExpireConfirmationModal({
  open, loading, errorMessage, onClose, onConfirm, vin, mode,
}) {
  const action = mode === 'expire' ? 'expire' : 'unexpire';

  const handleCancel = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Confirm
      open={open}
      closeIcon
      closeOnEscape={!loading}
      closeOnDimmerClick={false}
      header={mode === 'expire' ? 'Expire Guarantee' : 'Unexpire Guarantee'}
      content={{
        children: (
          <>
            <p>
              Are you sure you want to {action} this guarantee
              {vin ? <> for VIN <b>{vin}</b></> : null}?
            </p>
            {errorMessage && (
              <Message negative>
                <p>{errorMessage}</p>
              </Message>
            )}
          </>
        ),
      }}
      cancelButton={{ content: 'Cancel', disabled: loading }}
      confirmButton={{
        content: 'OK',
        loading,
        disabled: loading,
        'data-testid': 'expire-guarantee-confirm-button',
      }}
      onCancel={handleCancel}
      onConfirm={onConfirm}
    />
  );
}

ExpireConfirmationModal.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  vin: PropTypes.string,
  mode: PropTypes.oneOf(['expire', 'unexpire']),
};

ExpireConfirmationModal.defaultProps = {
  open: false,
  loading: false,
  errorMessage: null,
  vin: '',
  mode: 'expire',
};

export default ExpireConfirmationModal;
